import React, { useState } from 'react';
import './TornadoContent.css';
import { ReactComponent as TornadoIcon } from '../../assets/img/modal/tornado_detection.svg';
import { TornadoMarker } from '../../services/tornado/tornadoService';
import { RADAR_RADIAL_VELOCITY_IMAGE_URL } from '../../constants';
import { formatDateFromNumbers, formatTimeFromNumber } from '../../utils/date';

interface TornadoContentProps {
  tornado: TornadoMarker;
}

const TornadoContent: React.FC<TornadoContentProps> = ({
  tornado
}) => {
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  const imageUrl = `${RADAR_RADIAL_VELOCITY_IMAGE_URL}/vel_plot_${tornado.id}.png`;

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const handleImageError = () => {
    setImageLoading(false);
    setImageError(true);
  };

  return (
    <div className="tornado-content">
      <div className='tornado-content-top'>
        <div className="tornado-content-header">
          <div>
            <TornadoIcon />
          </div>
          <div>
            <h2 className="tornado-content-title">Tornado Detection</h2>
          </div>
        </div>

        {/* Date and time information */}
        <div className="tornado-content-info">
          <div className="tornado-content-info-item">
            <p className='tornado-content-info-key'>Date:</p>
            <p className='tornado-content-info-value'>{formatDateFromNumbers(tornado.date)}</p>
          </div>
          <div className="tornado-content-info-item">
            <p className='tornado-content-info-key'>Time:</p>
            <p className='tornado-content-info-value'>{formatTimeFromNumber(tornado.timestamp)}</p>
          </div>
        </div>
      </div>

      {/* Details section */}
      <div className="tornado-content-details">
        <h4 className="tornado-content-details-title">More Details</h4>

        <div className="tornado-content-radar">
          {imageLoading && (
            <div className="tornado-image-loader">
              <div className="spinner"></div>
            </div>
          )}

          {imageError && (
            <div className="tornado-content-radar-placeholder">
              Unable to load radar image
            </div>
          )}

          <img
            src={imageUrl}
            alt="Tornado Radar Detection"
            className={`tornado-content-radar-image ${imageLoading ? 'loading' : ''}`}
            onLoad={handleImageLoad}
            onError={handleImageError}
            style={{ display: imageError ? 'none' : 'block' }}
          />
        </div>
      </div>
    </div>
  );
};

export default TornadoContent;